export default __webpack_public_path__ + "static/media/mandi-main.a80a4407.png";